/** Loading-screen tips. Each max 120 chars. */
export const loadingTips: string[] = [
  'Gunfire carries for a kilometre. Everything in that kilometre now knows your address.',
  'A shove buys you one second. Spend it backing up, not admiring the shove.',
  'Reload behind a wall, not in the middle of the road. The road does not care that you are busy.',
  'Search a container fully before you run. Half a backpack of beans is still half a backpack.',
  'Crouching is quieter. Creeping through a farmhouse kitchen is undignified, and alive.',
  'The Ledger buys anything with a serial number and asks nothing about where it came from.',
  'Wood walls hold the dead for a while. Scrap walls hold them longer. Nothing holds them forever.',
  'Lights, generators and engines draw a crowd. Cook in the dark if you want to eat alone.',
  'Warden checkpoints wave you through if your hands are empty. Keep them empty.',
  'If the radio reads out numbers after dark, write them down. Somebody in the Annex still counts.',
  'Bandage first, loot second. Bleeding out on a weapon crate is a common local tradition.',
  'Fennick still has a working church bell. Nobody rings it on purpose.',
];
